module.exports = __webpack_public_path__ + "assets/img/icon2.d4861fcb.png";